import * as React from 'react'
import * as PropTypes from 'prop-types'

// assets
import appStore from '../../../../assets/img/app-download/app-store.png'
import playStore from '../../../../assets/img/app-download/play-store.png'

// components
import Icon from '../../../../components/ui/Icon/Icon'
import LoungeModal from '../../../../components/home/LoungeModal/LoungeModal'
import UseLoungePassModal from '../../../../components/home/UseLoungePassModal/UseLoungePassModal'
import LoungePassExhaustedModal from '../../../../components/home/LoungePassExhaustedModal/LoungePassExhaustedModal'
import WifiModal from '../../../../components/home/WifiModal/WifiModal'
import ZingBadgeModal from '../../../../components/home/ZingBadgeModal/ZingBadgeModal'
import CinemaModal from '../../../../components/home/CinemaModal/CinemaModal'
import GenericDownloadAppModal from '../../../../components/home/GenericDownloadAppModal/GenericDownloadAppModal'
import ExternalRedirectModal from '../../../../components/home/ExternalRedirectModal/ExternalRedirectModal'
import GCashModal from '../../../../components/home/GCashModal/GCashModal'
import ZingPointsBanner from './ZingPointsBanner/ZingPointsBanner'
import GCashStatus from './GCashStatus/GCashStatus'
import {
  MenuItem,
  StyledNormalLink,
  MenuIcon,
  MenuLabel,
  MenuSublabel,
  StyledLink,
  MainPage,
  Header,
  CloseButton,
  PointsInfo,
  PageBody,
  RewardsSectionContainer,
  ProfileCard,
  ProfileDetails,
  StyledAvatarContainer,
  StyledAvatar,
  ProfileBadge,
  BadgeProfileInfo,
  AdvancedNameRow,
  AdvancedName,
  AdvancedViewProfileLink,
  MemberDate,
  ProfileInfo,
  NameRow,
  Name,
  ViewProfileLink,
  MenuContainer,
  UpdateProfileButton,
  MissingDataIcon,
  MissingDataMessage,
  MissingDataHeader,
  MissingDataBody,
  StyledVerifyEmailCard,
  ProfileNav,
  StyledNotificationCount,
  Store,
  StoreButtons,
  Footer,
  StyledPrivacyModalLink,
  StyledTncModalLink,
  ItemName,
  NavLink,
  NavItem,
  RightButton,
} from './ProfilePage.style'

// data
import dateFormat from '../../../../services/data/dateFormat'
import gCashStatus from '../../../../services/data/gCashStatus'
import numberFormat from '../../../../services/data/numberFormat'
import {
  VOUCHERS,
  MESSAGES,
  MANAGE_CARDS,
  FAQ_PAGE,
  UPDATE_PROFILE,
  SETTINGS,
  HELP_CENTER,
  TRANSPORTATION,
  UPDATE_MISSING_DATA,
} from '../../../../services/data/profilePages.json'

// analytics
import { setGAEvent } from '../../../../services/analytics/google-analytics'

// redirection
import downloadAppLink from '../../../../services/redirection/downloadAppLink'

// controllers
import { doGetTicketCount } from '../../../../controllers/Watch'
import { doGetUnreadtNotificationCount } from '../../../../controllers/Notifications'
import { doGetUserLoyaltyPoints } from '../../../../controllers/Loyalty'
import { doGetFeatureStatuses } from '../../../../controllers/Features'
import {
  doGetGCashStatus,
  doLinkGCash,
  doUnlinkGCash,
} from '../../../../controllers/GCash'
import {
  doGetAccountStatus,
  doVerifyEmail,
  doGetEmailVerificationStatus,
  doClaimLoungePass,
} from '../../../../controllers/Profile'
import {
  FEATURES_LIST,
  withFeatureMaintenance,
} from '../../../../services/hooks/useFeatureMaintenance'
import FeatureMaintenanceModal from '../../../../components/home/FeatureMaintenanceModal/FeatureMaintenanceModal'
import { featureStatusesData } from '../../../../static/constants'

const refreshDetails = async props => {
  const { accessToken, setAccountStatus } = props
  doGetAccountStatus({ accessToken, setAccountStatus })
}

class ProfilePage extends React.Component {
  state = {
    scrollPosition: 0,
    hasScrolled: false,
    displayLoungeModal: false,
    displayUseLoungePassModal: false,
    displayLoungePassExhaustedModal: false,
    displayDownloadAppModal: false,
    displayExternalRedirectModal: false,
    usingLoungePass: false,
    sendingVerify: false,
    displayZingBadgePlusModal: false,
    updatedAccountData: null,
    showGCAshModal: false,
    gCashData: {},
    loadingGCashStatus: null,
    showMaintenanceModal: false,
    loungePassLeft: 0,
    contactId: '',
  }

  currentPage = React.createRef()

  componentDidMount() {
    const {
      accessToken,
      setFeatureStatus,
      featureStatus,
      featureMaintenance: { refreshFeatureStatus: refreshFeatureMaintenance },
    } = this.props
    refreshDetails(this.props)
    this.getLoyaltyPoints()
    this.getNotificationCount()
    this.getEmailVerification()
    this.loadGCash()
    refreshFeatureMaintenance()

    if (!featureStatus || (featureStatus && featureStatus.length === 0))
      doGetFeatureStatuses({ accessToken, setFeatureStatus })

    this.currentPage.current.addEventListener('scroll', this.handleScroll)
    // setGAEvent('page', 'page_visit', 'cinemas')
  }

  componentWillUnmount() {
    this.currentPage.current.removeEventListener('scroll', this.handleScroll)
  }

  setWifiModalVisible = b => () => {
    this.setState({
      displayWifiModal: b,
    })
  }

  setCinemaModalVisible = b => () => {
    this.setState({
      displayCinemaModal: b,
    })
  }

  handleVerifyClick = async () => {
    const { accessToken, setEmailVerificationStatus } = this.props

    if (accessToken) {
      try {
        this.setState({ sendingVerify: true })

        setTimeout(() => {
          this.setState({ sendingVerify: false })
        }, 2000)

        doVerifyEmail({ accessToken, setEmailVerificationStatus })
      } catch (err) {}
    }
  }

  showAppModal = () => {
    const { displayProfileModal, setDisplayAppModal, push } = this.props

    push('/main/download-app')
    setDisplayAppModal(true)
    displayProfileModal(false)
  }

  logout = () => {
    const { push, displayProfileModal, setPrimaryInfo } = this.props

    displayProfileModal(false)

    if (push) {
      setPrimaryInfo(false)
      push('/logout')
    }
  }

  getLoyaltyPoints = async () => {
    const { accessToken, advanceAccount, setLoyaltyPoints } = this.props
    await doGetUserLoyaltyPoints({
      accessToken,
      setLoyaltyPoints,
      isAdvancedAccount: advanceAccount && advanceAccount.advanced,
    })
  }

  getNotificationCount = async () => {
    const { setNotificationCount, setTicketCount, accessToken } = this.props

    if (accessToken) {
      await doGetUnreadtNotificationCount({ accessToken, setNotificationCount })
      await doGetTicketCount({ accessToken, setTicketCount })
    }
  }

  getEmailVerification = async () => {
    const { setEmailVerificationStatus, accessToken } = this.props
    doGetEmailVerificationStatus({ setEmailVerificationStatus, accessToken })
  }

  setRedirection = () => {
    const { setRedirectAfterAuth, displayProfileModal, location } = this.props
    const { pathname } = location || {}

    setRedirectAfterAuth(pathname)
    displayProfileModal(false)
  }

  handleScroll = event => {
    const { hasScrolled: hasScrolledState } = this.state
    const { scrollTop } = event.target
    const hasScrolled = scrollTop > 0

    if (hasScrolled !== hasScrolledState) {
      this.setState({
        hasScrolled,
      })
    }
  }

  toggleLoungeModal = state => {
    const { advanceAccount } = this.props
    const { loungePassLeft } = this.state

    if (advanceAccount === null) {
      return
    }

    if (loungePassLeft === null) {
      this.toggleLoungeClaimModal(state)
      return
    }

    if (loungePassLeft < 1) {
      this.toggleLoungePassExhaustedModal(state)
      return
    }

    this.setState({
      displayUseLoungePassModal: state,
    })
  }

  toggleLoungePassExhaustedModal = state => {
    this.setState({
      displayLoungePassExhaustedModal: state,
    })
  }

  toggleLoungeClaimModal = state => {
    this.setState({
      displayLoungeModal: state,
    })
  }

  claim = async () => {
    const { accessToken, setAccountStatus } = this.props
    if (accessToken) {
      try {
        this.setState({
          usingLoungePass: true,
        })
        await doClaimLoungePass({
          accessToken,
          setAccountStatus,
          onSuccess: ({ loungePassLeft }) => {
            this.setState({ loungePassLeft })
          },
        })
        this.setState({
          displayUseLoungePassModal: false,
          displayLoungeModal: true,
        })
      } catch (err) {}
      this.setState({
        usingLoungePass: false,
      })
    }
  }

  handleClickWifi = e => {
    const { displayProfileModal, featureStatus } = this.props

    const wifiFeature = featureStatus
      ? featureStatus.filter(feature => feature.itemCode === 'WIFI')
      : null
    if (wifiFeature.description || !(wifiFeature.status === 2)) {
      // if (featureStatus.wifi.description || !featureStatus.wifi.active) {
      e.preventDefault()
      this.setWifiModalVisible(true)(e)
      return
    }
    displayProfileModal(false)
  }

  handleClickCinemas = e => {
    const { displayProfileModal, featureStatus } = this.props

    const cinemaFeature = featureStatus
      ? featureStatus.filter(feature => feature.itemCode === 'CINEMAS')
      : null
    if (cinemaFeature.description || !(cinemaFeature.status === 2)) {
      // if (featureStatus.cinema.description || !featureStatus.cinema.active) {
      e.preventDefault()
      this.setCinemaModalVisible(true)(e)
      return
    }
    displayProfileModal(false)
  }

  setZingPlusBadgeModal = b => {
    this.setState({
      displayZingBadgePlusModal: b,
    })
  }

  // handleZingPlusBadge = e => {
  //   if (e) {
  //     e.preventDefault()
  //   }
  //   this.setZingPlusBadgeModal(true)
  //   // this.setState({
  //   //   displayZingBadgePlusModal: true,
  //   // })
  // }

  setDownloadAppModalVisible = b => e => {
    if (e) {
      e.preventDefault()
    }
    this.setState({
      displayDownloadAppModal: b,
    })
  }

  setExternalRedirectModalVisible = b => e => {
    if (e) {
      e.preventDefault()
    }
    this.setState({
      displayExternalRedirectModal: b,
    })
  }

  isNormalLink = tileProps => tileProps.hasOwnProperty('href')

  getTileProps = (itemCode, status) => {
    const {
      setProfileModalPage,
      displayProfileModal,
      accessToken,
      featureMaintenance: { isFeatureAvailable },
    } = this.props

    const functionData = {
      EXPLORE: { to: '/explore', onClick: () => displayProfileModal(false) },
      EGIFT: {
        href: 'https://ayalamalls.giftaway.ph',
        onClick: this.setExternalRedirectModalVisible(true),
      },
      LOUNGEPASS: accessToken
        ? {
            href: '#',
            onClick: () => {
              setGAEvent('profile_page', 'action_tile', 'lounge_pass')
              this.toggleLoungeModal(true)
            },
          }
        : {
            to: '/login',
            onClick: () => {
              setGAEvent('profile_page', 'action_tile', 'lounge_pass')
              displayProfileModal(false)
            },
          },
      TRANSPORTATION: {
        href: '#',
        onClick: () => {
          setGAEvent('profile_page', 'action_tile', 'transport')
          setProfileModalPage(TRANSPORTATION)
        },
      },
      CINEMAS: { to: '/', onClick: () => displayProfileModal(false) },
      /* ST-9198 - Profile :: Remove E-Concierge Tile */
      /* ECONCIERGE: {
        to: '/econcierge',
        onClick: () => {
          setGAEvent('profile_page', 'action_tile', 'e_concierge')
          displayProfileModal(false)
        },
      }, */
      ...(isFeatureAvailable(FEATURES_LIST.PARKING_VOUCHERS)
        ? {
            PARKING: {
              href: '#',
              onClick: this.setDownloadAppModalVisible(true),
            },
          }
        : {}),
    }
    if (status === 0 || itemCode === 'WIFI') return functionData[itemCode]
    if (status === 3 && itemCode === 'CINEMAS')
      // return { to: '/watch', onClick: this.handleClickCinemas }
      return { to: '/', onClick: this.handleClickCinemas }
    return {
      href: '#',
      onClick: this.setDownloadAppModalVisible(true),
    }
  }

  getTile = tileData => {
    const { id, title, status, imageUrl, itemCode } = tileData
    const tileProps = this.getTileProps(itemCode, status)

    if (status !== 1 && tileProps) {
      if (this.isNormalLink(tileProps))
        return (
          <MenuItem key={id}>
            <StyledNormalLink {...tileProps} key={id}>
              <MenuIcon src={imageUrl} />
              <MenuLabel>{title}</MenuLabel>
              {status === 2 && <MenuSublabel>Coming Soon</MenuSublabel>}
              {status === 3 && <MenuSublabel>Maintenance</MenuSublabel>}
            </StyledNormalLink>
          </MenuItem>
        )
      return (
        <MenuItem key={id}>
          <StyledLink {...tileProps} key={id}>
            <MenuIcon src={imageUrl} />
            <MenuLabel>{title}</MenuLabel>
            {status === 2 && <MenuSublabel>Coming Soon</MenuSublabel>}
            {status === 3 && <MenuSublabel>Maintenance</MenuSublabel>}
          </StyledLink>
        </MenuItem>
      )
    }

    return <></>
  }

  loadGCash = async () => {
    const { accessToken } = this.props
    await doGetGCashStatus({
      accessToken,
      onSuccess: ({ data: gCashData }) => {
        this.setState({ gCashData, errorMessage: null })
      },
      onError: () => {
        this.setState({
          errorMessage: 'Unable to Retrieve GCash Data',
        })
      },
    })
  }

  linkGCash = async () => {
    const { accessToken } = this.props
    await doLinkGCash({
      accessToken,
      onSuccess: ({ data: gCashData }) => {
        this.setState({
          showGCAshModal: false,
          displayLoungePassExhaustedModal: false,
          gCashData,
          errorMessage: null,
        })
      },
      onError: e => {
        const message =
          e && e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : 'Unable to request GCash Linking'
        this.setState({
          showGCAshModal: true,
          displayLoungePassExhaustedModal: false,
          errorMessage: message,
        })
      },
    })
  }

  unLinkGCash = async () => {
    const { accessToken } = this.props

    await doUnlinkGCash({
      accessToken,
      onSuccess: ({ data: gCashData }) => {
        this.setState({
          showGCAshModal: false,
          gCashData,
          errorMessage: null,
        })
      },
      onError: e => {
        const message =
          e && e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : 'Unable to request GCash Linking'
        this.setState({
          showGCAshModal: true,
          errorMessage: message,
        })
      },
    })
  }

  toggleGCashModal = () => {
    const { gCashData } = this.state
    if (
      gCashData &&
      (gCashData.status === gCashStatus.noRequest ||
        gCashData.status === gCashStatus.verified ||
        gCashData.status === gCashStatus.enrolled ||
        gCashData.status === gCashStatus.invalid)
    ) {
      this.setState({
        showGCAshModal: !this.state.showGCAshModal,
        errorMessage: null,
      })
    }
  }

  changeNumber = () => {
    const { setProfileModalPage } = this.props
    setProfileModalPage(UPDATE_PROFILE)
  }

  triggerAppOpen = () => {
    window.location.href = 'https://go.onelink.me/7htq/gcashzing'
  }

  handleClickMyVouchers = () => {
    const {
      featureMaintenance: { isFeatureAvailable },
      setProfileModalPage,
    } = this.props
    setGAEvent('profile_page', 'action_tile', 'my_vouchers')
    if (isFeatureAvailable()) {
      setProfileModalPage(VOUCHERS)
    } else {
      this.setState({ showMaintenanceModal: true })
    }
  }

  toggleMaintenanceModal = () => {
    this.setState({ showMaintenanceModal: !this.state.showMaintenanceModal })
  }

  render() {
    const {
      hasScrolled,
      displayLoungeModal,
      displayUseLoungePassModal,
      displayLoungePassExhaustedModal,
      displayWifiModal,
      displayCinemaModal,
      displayDownloadAppModal,
      displayExternalRedirectModal,
      usingLoungePass,
      displayZingBadgePlusModal,
      // updatedAccountData: advanceAccount,
      showGCAshModal,
      gCashData,
      // loadingGCashStatus,
      errorMessage,
      showMaintenanceModal,
    } = this.state
    const {
      // loyaltyPoints,
      primaryInfo,
      setProfileModalPage,
      displayProfileModal,
      accessToken,
      emailVerificationStatus,
      notificationCount,
      advanceAccount, //: advanceAccountData,
      featureStatus,
      // ticketCount,
    } = this.props
    const {
      firstName = '...',
      email = '',
      avatarUrl = '',
      createdAt = '',
      mobileNumber = '',
      birthdate = '',
      gender = '',
    } = primaryInfo || {}

    const isAdvanced = accessToken && advanceAccount && advanceAccount.advanced

    const cinemaFeature =
      featureStatus &&
      featureStatus.filter(feature => feature.itemCode === 'CINEMAS')[0]
    const wifiFeature =
      featureStatus &&
      featureStatus.filter(feature => feature.itemCode === 'WIFI')[0]
    const displayUpdateMissingData = !birthdate || gender === null

    return (
      <MainPage ref={this.currentPage}>
        <Header hasScrolled={hasScrolled}>
          <CloseButton onClick={() => displayProfileModal(false)}>
            <Icon name="x" />
          </CloseButton>
        </Header>

        <PointsInfo isAdvanced={isAdvanced}>
          {/* ST-7045 - [Web] Profile :: Advanced : Remove Points Display */}
          {/* {isAdvanced && (
            <>
              {loyaltyPoints.available || loyaltyPoints.available === 0 ? (
                <>
                  <PointsAmount>
                    {loyaltyPoints && numberFormat(loyaltyPoints.available)}
                  </PointsAmount>
                  <PointsDate>
                    Zing Points
                    <br />
                    As of {loyaltyPoints && dateFormat(loyaltyPoints.updatedAt)}
                  </PointsDate>
                </>
              ) : (
                <PointsDate>Calculating points...</PointsDate>
              )}
            </>
          )} */}
        </PointsInfo>

        <PageBody small={!accessToken} isAdvanced={isAdvanced}>
          <RewardsSectionContainer>
            {!!accessToken && (
              <>
                <ProfileCard>
                  <ProfileDetails>
                    <StyledAvatarContainer
                      hasBackground={!avatarUrl}
                      onClick={() => setProfileModalPage(UPDATE_PROFILE)}
                    >
                      <StyledAvatar variant="circle" src={avatarUrl} />
                      <ProfileBadge verified={emailVerificationStatus === 2}>
                        {emailVerificationStatus === 2 && <Icon name="check" />}
                      </ProfileBadge>
                    </StyledAvatarContainer>
                    {isAdvanced ? (
                      <>
                        <BadgeProfileInfo
                          onClick={() => setProfileModalPage(UPDATE_PROFILE)}
                        >
                          <AdvancedNameRow>
                            <AdvancedName>{firstName}</AdvancedName>
                            <AdvancedViewProfileLink>
                              Manage Profile <Icon name="arrow-right" />
                            </AdvancedViewProfileLink>
                          </AdvancedNameRow>
                          <MemberDate>
                            Member since {dateFormat(createdAt)}
                          </MemberDate>
                        </BadgeProfileInfo>
                        {/* ST-7031 - Profile :: Zing Plus Badge : Remove Badge */}
                        {/* <UserBadge onClick={this.handleZingPlusBadge}>
                          <img src={ZingPlusBadge} alt="Zing plus badge" />
                        </UserBadge> */}
                      </>
                    ) : (
                      <ProfileInfo
                        onClick={() => setProfileModalPage(UPDATE_PROFILE)}
                      >
                        <NameRow>
                          <Name>{firstName}</Name>
                          <ViewProfileLink>
                            Manage Profile <Icon name="arrow-right" />
                          </ViewProfileLink>
                        </NameRow>
                        <MemberDate>
                          Member since {dateFormat(createdAt)}
                        </MemberDate>
                      </ProfileInfo>
                    )}
                  </ProfileDetails>
                </ProfileCard>
              </>
            )}
          </RewardsSectionContainer>
          <MenuContainer>
            {featureStatusesData &&
              featureStatusesData.map(tileData => this.getTile(tileData))}
          </MenuContainer>

          <ZingPointsBanner
            accessToken={accessToken}
            advanceAccount={advanceAccount}
            joinNowCallback={e => {
              displayProfileModal(false)
              this.setRedirection(e)
            }}
            loginCallback={e => {
              displayProfileModal(false)
              this.setRedirection(e)
            }}
            gCashCallback={this.toggleGCashModal}
            setProfileModalPage={setProfileModalPage}
          />

          {/* ? Soon to be removed ? */}
          <GCashStatus
            advanceAccount={advanceAccount && advanceAccount.advanced}
            gCashData={gCashData}
            gCashCallback={this.toggleGCashModal}
          />

          {/* Removed Update My Profile Banner (ST-9159)*/}
          {/* Test Deploy */}

          {!!accessToken &&
            emailVerificationStatus !== null &&
            emailVerificationStatus !== 2 && (
              <StyledVerifyEmailCard
                accessToken={accessToken}
                firstName={firstName}
                email={email}
                verifyState={emailVerificationStatus}
                sendingVerify={this.state.sendingVerify}
                onVerifyClick={this.handleVerifyClick}
              />
            )}
          <ProfileNav>
            {accessToken ? (
              <>
                <NavItem onClick={() => setProfileModalPage(MESSAGES)}>
                  <ItemName>
                    Inbox
                    <StyledNotificationCount count={notificationCount} />
                  </ItemName>
                  <Icon name="slide-right" />
                </NavItem>
                <NavItem onClick={this.handleClickMyVouchers}>
                  <ItemName>My Vouchers</ItemName>
                  <Icon name="slide-right" />
                </NavItem>
                {/* ST-1555 hide cinemas activities */}
                {/* <NavItem onClick={() => setProfileModalPage(TICKETS)}>
                  <ItemName>
                    My Movie Tickets
                    <StyledNotificationCount count={ticketCount} />
                  </ItemName>
                  <Icon name="slide-right" />
                </NavItem> */}
                <NavItem onClick={() => setProfileModalPage(SETTINGS)}>
                  <ItemName>Settings</ItemName>
                  <Icon name="slide-right" />
                </NavItem>
                <NavItem onClick={() => setProfileModalPage(HELP_CENTER)}>
                  <ItemName>Help Center</ItemName>
                  <Icon name="slide-right" />
                </NavItem>

                {/*
                ST -6750 - ST - 6803 - remove Refer a Friend option
                {advanceAccount && advanceAccount.advanced && (
                  <NavItem onClick={() => setProfileModalPage(REFER)}>
                    <ItemName>Refer a Friend</ItemName>
                    <Icon name="slide-right" />
                  </NavItem>
                )} */}
                <NavItem onClick={this.showAppModal}>
                  <ItemName>Rate Us</ItemName>
                  <Icon name="slide-right" />
                </NavItem>
                <NavItem onClick={this.logout}>
                  <ItemName>Logout</ItemName>
                  <Icon name="slide-right" />
                </NavItem>
              </>
            ) : (
              <>
                <NavLink
                  to="/login"
                  onClick={e => {
                    displayProfileModal(false)
                    this.setRedirection(e)
                  }}
                >
                  <NavItem>
                    <ItemName>My Vouchers</ItemName>
                    <Icon name="slide-right" />
                  </NavItem>
                </NavLink>
                <NavItem onClick={() => setProfileModalPage(FAQ_PAGE)}>
                  <ItemName>Frequently Asked Questions</ItemName>
                  <Icon name="slide-right" />
                </NavItem>
                {/* <NavItem onClick={() => setProfileModalPage(SHARE_FEEDBACK)}>
                  <ItemName>Share your Feedback</ItemName>
                  <Icon name="slide-right" />
                </NavItem> */}
                <NavItem>
                  <ItemName>
                    <StyledTncModalLink>Terms & Conditions</StyledTncModalLink>
                  </ItemName>
                  <Icon name="slide-right" />
                </NavItem>
                <NavItem>
                  <ItemName>
                    <StyledPrivacyModalLink>
                      Privacy Notice
                    </StyledPrivacyModalLink>
                  </ItemName>
                  <Icon name="slide-right" />
                </NavItem>
              </>
            )}
          </ProfileNav>
          <Footer>
            <StoreButtons>
              <Store src={appStore} onClick={downloadAppLink('iOS')} />
              <Store src={playStore} onClick={downloadAppLink('Android')} />
            </StoreButtons>
          </Footer>
        </PageBody>
        <UseLoungePassModal
          show={displayUseLoungePassModal}
          loungePassLeft={this.state.loungePassLeft}
          disabled={usingLoungePass}
          onClaim={() => this.claim()}
          onClose={() => this.toggleLoungeModal(false)}
          zIndex={10025}
        />
        <LoungePassExhaustedModal
          show={displayLoungePassExhaustedModal}
          isGCashValidating={
            gCashData && gCashData.status === gCashStatus.pendingLink
          }
          onGCashLink={() => this.toggleGCashModal()}
          onAdd={() => {
            this.toggleLoungePassExhaustedModal(false)
            setProfileModalPage(MANAGE_CARDS)
          }}
          onClose={() => this.toggleLoungePassExhaustedModal(false)}
          zIndex={10025}
        />
        <LoungeModal
          show={displayLoungeModal}
          unlimited={advanceAccount && this.state.loungePassLeft === null}
          onClose={() => this.toggleLoungeClaimModal(false)}
          zIndex={10025}
        />
        <WifiModal
          show={displayWifiModal}
          status={wifiFeature ? wifiFeature.status : 3}
          description={wifiFeature ? wifiFeature.description : null}
          onClose={this.setWifiModalVisible(false)}
          zIndex={10025}
        />
        {/* ? Soon to be removed ? */}
        <ZingBadgeModal
          show={displayZingBadgePlusModal}
          onClose={e => {
            e.stopPropagation()
            this.setZingPlusBadgeModal(false)
          }}
          zIndex={10040}
          // shouldCloseOnOverlayClick={true}
        />
        <CinemaModal
          show={displayCinemaModal}
          description={cinemaFeature ? cinemaFeature.description : null}
          // description={featureStatus ? featureStatus.cinema.description : null}
          onClose={this.setCinemaModalVisible(false)}
          zIndex={10025}
        />
        <GenericDownloadAppModal
          show={displayDownloadAppModal}
          onClose={this.setDownloadAppModalVisible(false)}
          zIndex={10025}
        />
        <ExternalRedirectModal
          show={displayExternalRedirectModal}
          to="https://ayalamalls.giftaway.ph/"
          onClose={() => this.setExternalRedirectModalVisible(false)()}
          onProceed={() => {
            setGAEvent('view_buyegift', 'on_proceed')
            this.setExternalRedirectModalVisible(false)()
          }}
          zIndex={10025}
        />

        {/* ? Soon to be removed ? */}
        <GCashModal
          show={showGCAshModal}
          zIndex={10025}
          gCashData={gCashData}
          onInvalid={this.triggerAppOpen}
          onLink={this.linkGCash}
          onUnLink={this.unLinkGCash}
          onClose={this.toggleGCashModal}
          mobileNumber={mobileNumber}
          onChangeNumber={this.changeNumber}
          errorMessage={errorMessage}
        />
        <FeatureMaintenanceModal
          show={showMaintenanceModal}
          onConfirmClick={this.toggleMaintenanceModal}
        />
      </MainPage>
    )
  }
}

ProfilePage.defaultProps = {}

ProfilePage.propTypes = {
  primaryInfo: PropTypes.object,
}

export default withFeatureMaintenance(ProfilePage, FEATURES_LIST.VOUCHERS)
